import { Input, InputRef } from "antd";
import React, { useState } from "react";
import styled from "styled-components";
import { InputPropsType } from "./InputPropsT";
import { theme } from "../../../theme";
import { ReactComponent as CancelBtn } from "../../../assets/icons/CancelBtn.svg";
import Explain from "../Explain";
import { StatusType } from "../Explain/types";

interface InputsProps extends InputPropsType {
  onChange: (e: string) => void;
  onClick?: any;
  onExplainClick?: () => void;
  height?: number;
  isPassword?: true;
  isNotBordered?: true;
  isNotShowPassword?: boolean;
  additionalBtn?: any;
  status?: StatusType;
  explain?: string;
  onBlur?: (e: string) => void;
  maxLength?: number;
  isAllowCancel?: boolean;
  showCount?: boolean;
  autoComplete?: string;
  onPressEnter?: () => void;
}

const TextInputs = React.forwardRef<InputRef, InputsProps>(
  (
    {
      children,
      disabled,
      placeholder,
      status,
      name,
      value,
      height,
      onChange,
      onClick,
      explain,
      onBlur = () => {},
      maxLength,
      onExplainClick,
      additionalBtn,
      isNotShowPassword,
      isNotBordered,
      isPassword,
      isAllowCancel,
      showCount,
      onPressEnter,
      autoComplete,
    },
    ref
  ) => {
    const styles = {
      height,

      placeholder,
      value,
      name,
    };
    const [isFocus, setFocus] = useState<boolean>(false);
    const [thisValue, setValue] = useState(value);
    const onReset = () => {
      setValue("");
      onChange("");
    };

    return (
      <InputContainer>
        {isNotBordered ? (
          isPassword && isNotShowPassword !== true ? (
            <NotBorderedInputWrapper status={status}>
              <NotBorderedPasswordInput
                onPressEnter={onPressEnter}
                ref={ref}
                onClick={onClick}
                onBlur={(e) => {
                  if (onBlur) onBlur(e.target.value);
                }}
                type={isPassword && "password"}
                disabled={disabled}
                // autoComplete="new-password"
                autoComplete={autoComplete || "new-password"}
                defaultValue={children as string}
                className="notBordered"
                maxLength={maxLength}
                {...styles}
                bordered={false}
                onChange={(e) => onChange(e.target.value)}
                showCount={
                  showCount === undefined ? maxLength !== undefined : showCount
                }
              />
              <StyledBtnWrapper disabled={disabled}>
                {additionalBtn}
              </StyledBtnWrapper>
            </NotBorderedInputWrapper>
          ) : (
            <NotBorderedInputWrapper status={status}>
              <NotBorderedInput
                onPressEnter={onPressEnter}
                ref={ref}
                onClick={onClick}
                onBlur={(e) => {
                  if (onBlur) onBlur(e.target.value);
                }}
                type={isPassword && "password"}
                disabled={disabled}
                autoComplete={autoComplete || "new-password"}
                defaultValue={children as string}
                className="notBordered"
                maxLength={maxLength}
                {...styles}
                bordered={false}
                onChange={(e) => onChange(e.target.value)}
                showCount={
                  showCount === undefined ? maxLength !== undefined : showCount
                }
              />
              <StyledBtnWrapper disabled={disabled}>
                {additionalBtn}
              </StyledBtnWrapper>
            </NotBorderedInputWrapper>
          )
        ) : isPassword ? (
          isNotShowPassword ? (
            <InputWrapper
              isFocus={isFocus}
              onFocus={() => {
                setFocus(true);
              }}
              disabled={disabled}
            >
              <DefaultInputs
                ref={ref}
                onPressEnter={onPressEnter}
                disabled={disabled}
                type={isPassword && "password"}
                defaultValue={children as string}
                className="input"
                autoComplete="none"
                {...styles}
                value={thisValue}
                onChange={(e) => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
              />
              {isAllowCancel && !disabled && value && (
                <StyledCancelBtnWrapper>
                  <CancelBtn
                    onClick={(e) => {
                      e.preventDefault();
                      if (onReset) onReset();
                    }}
                  />
                </StyledCancelBtnWrapper>
              )}
            </InputWrapper>
          ) : (
            <DefaultInputs.Password
              ref={ref}
              onPressEnter={onPressEnter}
              disabled={disabled}
              type={isPassword && "password"}
              defaultValue={children as string}
              className="input"
              autoComplete="none"
              {...styles}
              value={thisValue}
              onChange={(e) => {
                setValue(e.target.value);
                onChange(e.target.value);
              }}
            />
          )
        ) : (
          <InputWrapper
            isFocus={isFocus}
            onFocus={() => {
              setFocus(true);
            }}
            disabled={disabled}
          >
            <DefaultInputs
              ref={ref}
              onPressEnter={onPressEnter}
              disabled={disabled}
              type={isPassword && "password"}
              defaultValue={children as string}
              className="input"
              autoComplete="none"
              {...styles}
              value={thisValue}
              onChange={(e) => {
                setValue(e.target.value);
                onChange(e.target.value);
              }}
            />
            {isAllowCancel && !disabled && value && (
              <StyledCancelBtnWrapper>
                <CancelBtn
                  onClick={(e) => {
                    e.preventDefault();
                    if (onReset) onReset();
                  }}
                />
              </StyledCancelBtnWrapper>
            )}
          </InputWrapper>
        )}

        {explain && explain.length > 0 && (
          <StyledExplainWrapper>
            <Explain
              explain={explain}
              onClick={onExplainClick}
              status={status}
            />
          </StyledExplainWrapper>
        )}
      </InputContainer>
    );
  }
);

export default TextInputs;

const DefaultInputs = styled(Input)<{
  status?: StatusType;
  height?: number;
}>`
  padding: 0;
  transition: all 0.3s;
  border: none;
  outline: none;
  box-shadow: none;
  font-size: 14px;
  font-weight: 400;
  :disabled {
    background-color: ${theme.colors.gray9};
    color: black;
  }
  :hover {
    box-shadow: none;
    border: none;
    outline: none;
  }
  :active {
    box-shadow: none;
    border: none;
    outline: none;
  }
  :focus {
    box-shadow: none;
    border: none;
    outline: none;
  }
`;
const StyledExplainWrapper = styled.div`
  margin-top: 8px;
`;
const StyledCancelBtnWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 14px;
  cursor: pointer;
  padding-right: 6px;
  transition: all 0.3s;
`;
const InputWrapper = styled.span<{
  isFocus: boolean;
  disabled?: boolean;
  status?: StatusType;
}>`
  transition: all 0.3s;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: relative;
  display: inline-block;
  width: 100%;
  font-size: 14px;
  line-height: 24px;
  height: 32px;
  transition: all 0.3s;
  display: inline-flex;
  background-color: #f8f8f8;
  ${({ disabled }) =>
    disabled
      ? `color: rgba(0, 0, 0, 0.25);
background-color: #f5f5f5;
border-color: #d9d9d9;
box-shadow: none;
cursor: not-allowed;
opacity: 1;`
      : ` 
padding: 4px 11px;
color: rgba(0, 0, 0, 0.85);

background-color: #fff;
background-image: none;

`};

  &:focus {
    border-color: ${theme.colors.mainPrimary3};
  }
  border-color: ${({ status }) => {
    switch (status) {
      case "error":
        return theme.colors.blue2;
      case "success":
        return theme.colors.red3;
      default:
        return theme.colors.gray6;
    }
  }};
`;

const NotBorderedInputWrapper = styled.div<{ status?: StatusType }>`
  position: relative;
  display: flex;
  flex-wrap: no-wrap;
  border-bottom: 1px solid #d2d2d2;
  box-sizing: border-box;
  transition: all 0.3s;
  :hover {
    outline: none;
    box-shadow: none;
    border-color: none;
  }

  :focus-within {
    outline: none;
    box-shadow: none;

    border-bottom: 1px solid ${theme.colors.mainPrimary3};
    outline-bottom: 1px solid ${theme.colors.mainPrimary3};
  }
  border-color: ${({ status }) => {
    switch (status) {
      case "success":
        return theme.colors.blue2;
      case "error":
        return theme.colors.red3;
      default:
        return theme.colors.gray6;
    }
  }};
`;
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
const NotBorderedPasswordInput = styled(Input.Password)<{
  height?: number;
  onClick?: any;
}>`
  background-color: #fff;
  border: none;
  transition: all 0.3s;
  background: none;
  padding: 16px 4px;
  border-radius: 0px;
  width: 100%;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "text")};
  ${theme.typo.body.r16};
  :disabled {
    background-color: ${theme.colors.gray9};
    color: black;
  }
  & > input:-webkit-autofill,
  & > input:-webkit-autofill:hover,
  & > input:-webkit-autofill:focus,
  & > input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-transition: background-color 9999s ease-out;
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    ${theme.typo.body.r16};
  }
  &::placeholder {
    color: ${theme.colors.gray3};
    ${theme.typo.body.r14};
  }
  :hover {
    outline: none;
    box-shadow: none;
    border-color: none;
  }
  :focus {
    outline: none;
    box-shadow: none;
    border-color: none;
    box-shadow: none;
  }

  .ant-input-show-count-suffix {
    ${theme.typo.body.r12};
    color: ${theme.colors.gray5};
  }
  transition: all 0.3s;
`;
const NotBorderedInput = styled(Input)<{
  height?: number;
  onClick?: any;
}>`
  background-color: #fff;
  border: none;
  transition: all 0.3s;
  background: none;
  padding: 16px 4px;
  border-radius: 0px;
  width: 100%;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "text")};
  ${theme.typo.body.r16};
  :disabled {
    background-color: ${theme.colors.gray9};
    color: black;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-transition: background-color 9999s ease-out;
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }
  &::placeholder {
    color: ${theme.colors.gray3};
    ${theme.typo.body.r14};
  }
  :hover {
    outline: none;
    box-shadow: none;
    border-color: none;
  }
  :focus {
    outline: none;
    box-shadow: none;
    border-color: none;
    box-shadow: none;
  }

  .ant-input-show-count-suffix {
    ${theme.typo.body.r12};
    color: ${theme.colors.gray5};
  }
  transition: all 0.3s;
`;
const StyledBtnWrapper = styled.div<{ disabled?: boolean }>`
  flex: 1 1 0;
  right: 0;
  align-items: center;
  display: flex;
  background-color: ${({ disabled }) => {
    return disabled && theme.colors.gray9;
  }};
  align-items: center;
`;
